import { Box, Container, Grid, Typography, styled } from "@mui/material";
import React from "react";
import { appImages } from "../../assets";
import Header from "../header";
import AppFooter from "../footer";
import NavBar from "../NavBar";
import { t } from "i18next";

const CustomBox = styled(Box)(({ theme }) => ({
  background: theme.palette.gradient.background,
  position: "relative",
  minHeight: "80vh",
  maxWidth: "1200px",
  boxShadow: "10px 10px 60px 0px #00000040",
  borderRadius: "25px",
  margin: "0px 16px",
  margin: "auto",
  // marginTop: "10rem",
  [theme.breakpoints.down("md")]: {
    minHeight: "auto",
    width: "100%",
    borderRadius: "0px",
    margin: "0",
  },
}));

const LeftGridItem = styled(Grid)(({ theme }) => ({
  padding: "16px 24px",
  position: "relative",
  zIndex: 999,
  borderRadius: "30px ",
}));

const RightGridItem = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.text.white,
  padding: 24,
  borderRadius: "25px",
  minHeight: "80vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  paddingBottom: 35,
  [theme.breakpoints.down("md")]: {
    borderRadius: "0px",
    padding: "24px 8px",
    minHeight: "auto",
  },
}));

const LogoTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.875rem",
  fontWeight: 600,
  color: theme.palette.text.white,
}));

const SubtitleTypography = styled(Typography)(({ theme }) => ({
  marginTop: 24,
  fontWeight: 600,
  color: theme.palette.text.gainsboro,
  fontSize: "1.785rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "2.188rem",
  },
}));

const AuthContainer = ({ children }) => {
  return (
    <>
      <NavBar />
      <Box
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          backgroundImage: `url(${appImages.educationCityDetailBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}

        {/* wave image */}
        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      </Box>
      <Box position={"absolute"} top={{ xs: 130, sm: 150 }} left={0} right={0}>
        <CustomBox sx={{ position: "relative", zIndex: 999 }}>
          <Grid container>
            <LeftGridItem item xs={12} md={5}>
              <LogoTypography variant="h1" textTransform={"capitalize"}>
                {t("marketPlace")}
              </LogoTypography>
              <Typography variant="body2" color={"text.white"}>
                {t("poweredBy")}
              </Typography>
              <SubtitleTypography variant="h1">
                {t("problemSolution")}
              </SubtitleTypography>
              <Typography variant="body2" color={"text.white"}>
                {t("forgotDescription")}
              </Typography>
              <Box
                component={"img"}
                src={appImages.authBg}
                alt="auth-image"
                width={"100%"}
                sx={{
                  display: { xs: "none", sm: "block" },
                }}
                // height={"100%"}
              />
            </LeftGridItem>
            <RightGridItem item xs={12} md={7}>
              <Container
                sx={{
                  maxWidth: "520px !important",
                  "& .MuiOutlinedInput-notchedOutline": {
                    // borderColor:"primary.main",
                    // borderWidth:2
                  },
                }}
              >
                {children}
              </Container>
            </RightGridItem>
          </Grid>
        </CustomBox>
        <AppFooter bgcolor={true} />
      </Box>
    </>
  );
};

export default AuthContainer;
